// @docs https://[domain]/api/v1/docs
export default {
  Create: "/pyr/employees/payroll-templates",
  List: "/pyr/employee-templates",
  Detail: "/pyr/employee-templates/{id}",
  Active: "/pyr/employee-templates/{id}/active",
  Delete: "/pyr/employee-templates/{id}/{templateCode}/{empCode}",
  Inactive: "/pyr/employee-templates/{id}/inactive",
  Assign: "/pyr/employee-templates",
  AssignTemplates: "/pyr/employee-templates/assign",
  RemoveTemplates: "/pyr/employee-templates/remove",
};
